import * as React from "react";
import { TextField } from "@mui/material";
import { formatearDia } from "../../../common/calendarDate";

type ShowDateProps = {
  label: string;
  /** Un día de calendario, "AAAA-MM-DD" (fecha sin hora), o null. */
  value: string | null;
  /** El formato del idioma (langStore.timeFormat: "es-AR", "en-US", "pt-BR"). Por defecto, "es-AR". */
  locale?: string;
  helperText?: string;
  customWidth?: number;
  hidden?: boolean;
};

export const ShowDate: React.FC<ShowDateProps> = ({
  label,
  value,
  locale = "es-AR",
  helperText = "",
  customWidth = 500,
  hidden = false,
}) => {
  if (hidden) return null;
  // El día con Intl en zona UTC: la zona del navegador no lo corre.
  const strData = formatearDia(value, locale);
  return (
    <div style={{ display: "flex" }}>
      <TextField
        size={"small"}
        inputProps={{ autoComplete: "one-time-code" }}
        helperText={helperText}
        sx={{ m: 1, mb: 1.5, width: customWidth }}
        label={label}
        value={strData}
        InputLabelProps={{ shrink: true }}
      />
    </div>
  );
};
